var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 67,
    viewBox: "0 0 69 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1239 66H15.0356C10.1231 65.9999 1.3509 62.4768 1.35089 52.5967C1.35088 42.7206 1.11696 23.3214 1 14.8562C1 9.21269 6.19318 1.10032 15.7374 1.10032C25.2816 1.10032 42.1711 1.10032 49.4228 1.10032C54.8031 0.512464 65.5638 2.22901 65.5638 13.7981C65.5638 25.3672 65.5638 29.4351 65.5638 30.0229M10.8249 15.5616L16.0883 19.7942L24.5096 9.91813M10.474 32.8446L16.0883 37.0772L24.8605 26.8485M10.474 51.5386L16.0883 55.7712L24.8605 45.8951M33.2819 33.1974H55.7388M33.2819 15.9143H55.7388M41.7032 55.4184L48.721 62.12M41.7032 55.4184L38.8961 65.2945L48.721 62.12M41.7032 55.4184L56.3775 40.9571M48.721 62.12C52.4302 58.3916 58.8966 51.8916 63.1075 47.6587M56.3775 40.9571L59.5986 37.7827C61.3531 36.0191 62.8268 35.7369 64.5111 37.4299C66.1954 39.123 67.0843 40.0165 67.3182 40.2517C67.903 40.722 68.6516 42.0858 66.9673 43.7788C66.4442 44.3047 65.0048 45.7516 63.1075 47.6587M56.3775 40.9571L63.1075 47.6587",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.be8ea733b61f48229582e271303caf10.svg";
export { ForwardRef as ReactComponent };